module.exports = __webpack_public_path__ + "9933ab724ac62360a2bc7f62ba08f44b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/articlBg.jpg
// module id = 1099
// module chunks = 0